// Conversion Vola ↔ Devises
// Basé sur le catalogue de récompenses : 800 Vola = 5 000 Ar = ~1 €
// (taux Ar/€ stable autour de 5 000 Ar/€ à Madagascar)

export const VOLA_PER_EUR = 800;        // 800 Vola = 1 €
export const VOLA_PER_ARIARY = 800 / 5000; // 1 Vola = 6.25 Ar

export const volaToEur = (vola) => (Number(vola || 0) / VOLA_PER_EUR);
export const volaToAriary = (vola) => Math.round(Number(vola || 0) / VOLA_PER_ARIARY);

// Format propre, avec décimales adaptatives (les petits montants en cents)
export const fmtEur = (vola, opts = {}) => {
  const eur = volaToEur(vola);
  if (eur === 0) return "0 €";
  if (eur < 0.01) return "< 0,01 €";
  const decimals = eur < 10 ? 2 : eur < 100 ? 1 : 0;
  return eur.toLocaleString("fr-FR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    ...opts,
  }) + " €";
};

export const fmtAriary = (vola) => volaToAriary(vola).toLocaleString("fr-FR") + " Ar";
